import { Component, OnChanges, OnInit, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { FilterBase } from 'src/app/shared/grid/filter-base';
import { Lookup } from 'src/app/shared/models/lookup.model';
import { FacilityVaccineService } from 'src/app/shared/services/facility-vaccine.service';

@Component({
    selector: 'nova-facility-vaccine-filter-popup',
    templateUrl: './grid-facility-vaccine-filter-popup.component.html',
    styleUrls: ['./grid-facility-vaccine-filter-popup.component.scss']
})
export class GridFacilityVaccineFilterPopupComponent extends FilterBase implements OnInit, OnChanges {
    vaccineTypes$: Observable<Lookup[]>;
    vaccineStatuses$: Observable<Lookup[]>;

    isFilterActive = false;

    @ViewChildren(FilterBase) filters: QueryList<FilterBase>;

    constructor(private readonly _facilityVaccineService: FacilityVaccineService) {
        super();
    }

    ngOnInit(): void {
        this.vaccineTypes$ = this._facilityVaccineService.getVaccineTypes();
        this.vaccineStatuses$ = this._facilityVaccineService.getVaccineStatuses().pipe(share());
    }

    filterValueChanged(): void {
        this.isFilterActive = this.getIsFilterActive();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['filter']) {
            this.filterValueChanged();
        }
    }

    getIsFilterActive(): boolean {
        const covValues = this.getLatestFilterValue(null, 'covVaccinationStatusIds');
        if (covValues && covValues.length > 0) {
            return true;
        }
        const fluValues = this.getLatestFilterValue(null, 'fluVaccinationStatusIds');
        if (fluValues && fluValues.length > 0) {
            return true;
        }

        return false;
    }

    onPopupClose(): void {
        if (this.filters.toArray().some((x) => x.isChanged)) {
            this.submitFilter();
        }
    }

    onResetClick(): void {
        this.trimFilterByField(this.filter, 'covVaccinationStatusIds');
        this.trimFilterByField(this.filter, 'fluVaccinationStatusIds');
        this.submitFilter();
        this.filterValueChanged();
    }

    onFilterClick(): void {
        this.submitFilter();
    }

    submitFilter(): void {
        this.filters.toArray().forEach((x) => (x.isChanged = false));
        super.submitFilter();
    }

    getFieldName(vaccineType: Lookup): string {
        return `${vaccineType.name.toLocaleLowerCase()}VaccinationStatusIds`;
    }
}
